var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    [
      _c(
        "el-col",
        {
          staticStyle: { padding: "80px 40px 20px 40px" },
          attrs: { span: 24 }
        },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      border: "4px solid #cccccc",
                      "border-radius": "30px",
                      padding: "20px"
                    }
                  },
                  [
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          {
                            staticClass: "d-flex jc-center",
                            attrs: { span: 24 }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "color-green text-w600 text-dino text-40"
                              },
                              [_vm._v("Reservation Form")]
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { staticStyle: { "margin-top": "10px" } },
                      [
                        _c(
                          "el-col",
                          {
                            staticClass: "d-flex jc-center ac-center",
                            attrs: { span: 24 }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "text-dino text-w600 text-36 color-green"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.listingDetails.apt) +
                                    " / " +
                                    _vm._s(_vm.listingDetails.address) +
                                    ",\n            " +
                                    _vm._s(_vm.listingDetails.suburb)
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("el-divider", {
                              staticStyle: { padding: "0 5px" },
                              attrs: { direction: "vertical" }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "text-dino text-w400 text-36 color-green"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.listingDetails.state) +
                                    " " +
                                    _vm._s(_vm.listingDetails.postcode)
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { staticStyle: { "margin-top": "10px" } },
                      [
                        this.getOfferType() == "Select now"
                          ? _c(
                              "el-col",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "center"
                                },
                                attrs: { span: 24 }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "listing-price-state",
                                    staticStyle: { "margin-top": "0" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.displayPrice(_vm.listingDetails)
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.listingDetails.price != 0
                                  ? _c("el-divider", {
                                      staticClass: "mlf-30",
                                      attrs: { direction: "vertical" }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", { staticClass: "chip-gray" }, [
                                  _vm._v(
                                    _vm._s(_vm.listingDetails.propertyType)
                                  )
                                ])
                              ],
                              1
                            )
                          : _c(
                              "el-col",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "center"
                                },
                                attrs: { span: 24 }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "listing-price-state",
                                    staticStyle: { "margin-top": "0" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.displayPrice(_vm.listingDetails)
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("el-divider", {
                                  staticClass: "mlf-30",
                                  attrs: { direction: "vertical" }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "chip-gray" }, [
                                  _vm._v(
                                    _vm._s(_vm.listingDetails.propertyType)
                                  )
                                ])
                              ],
                              1
                            )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      [
                        _vm.$route.query.type == "2"
                          ? _c(
                              "el-col",
                              {
                                staticStyle: {
                                  "margin-top": "20px",
                                  "line-height": "1.5"
                                },
                                attrs: { span: 24 }
                              },
                              [
                                _c(
                                  "el-row",
                                  { staticStyle: { "margin-top": "20px" } },
                                  [
                                    _c(
                                      "el-col",
                                      {
                                        staticClass: "d-flex jc-center",
                                        attrs: { span: 24 }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-22 text-w400 text-dino text-center"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    1. Complete the online form with all details of the purchaser and\n                    conveyancer or solicitor. Please complete all details carefully as\n                    they will be used to prepare the contract of sale and enable the Concierge service to contact your client to progress the sale.\n                  "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      {
                                        staticClass: "d-flex jc-center",
                                        attrs: { span: 24 }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-22 text-w400 text-dino text-center"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    2. Click “Pay and Submit Reservation” to pay the $1,000\n                    reservation fee securely online.\n                  "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      {
                                        staticClass: "d-flex jc-center",
                                        attrs: { span: 24 }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              " text-22 text-w400 text-dino text-center"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    3. Once your reservation is received, the Concierge Service will contact you\n                    directly to prepare the contract of sale and take you through next\n                    steps.\n                  "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      {
                                        staticClass: "d-flex jc-center",
                                        attrs: { span: 24 }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-22 text-w400 text-dino text-center"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    4. Upon the expiry of the 7-day reservation period, your $1,000\n                    reservation fee will be refunded to your original method of\n                    payment.\n                  "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "reservationForm",
              attrs: {
                model: _vm.reservationForm,
                rules: _vm.reservationFormRules
              }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: { "margin-top": "20px" },
                      attrs: { span: 24 }
                    },
                    [
                      _c("span", { staticClass: "title-reservation-section" }, [
                        _vm._v("Purchaser Details")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.reservationForm.allPurchaser, function(
                    purchaser,
                    index
                  ) {
                    return _c(
                      "div",
                      { key: index },
                      [
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              {
                                staticStyle: { "margin-top": "10px" },
                                attrs: { span: 24 }
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "title-purchaser-section" },
                                  [
                                    _vm._v(
                                      "Purchaser #" +
                                        _vm._s(purchaser.purchaserId)
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          {
                            staticStyle: { "margin-top": "20px" },
                            attrs: { gutter: 20 }
                          },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "allPurchaser." + index + ".title"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { display: "inline" },
                                        attrs: { placeholder: "Title" },
                                        model: {
                                          value: purchaser.title,
                                          callback: function($$v) {
                                            _vm.$set(purchaser, "title", $$v)
                                          },
                                          expression: "purchaser.title"
                                        }
                                      },
                                      _vm._l(_vm.titles, function(t) {
                                        return _c("el-option", {
                                          key: t.id,
                                          attrs: {
                                            label: t.title,
                                            value: t.title
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 18 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop:
                                        "allPurchaser." + index + ".firstName"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "First name" },
                                      model: {
                                        value: purchaser.firstName,
                                        callback: function($$v) {
                                          _vm.$set(purchaser, "firstName", $$v)
                                        },
                                        expression: "purchaser.firstName"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "Middle names" },
                                      model: {
                                        value: purchaser.middleName,
                                        callback: function($$v) {
                                          _vm.$set(purchaser, "middleName", $$v)
                                        },
                                        expression: "purchaser.middleName"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "allPurchaser." + index + ".surName"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "Surname" },
                                      model: {
                                        value: purchaser.surName,
                                        callback: function($$v) {
                                          _vm.$set(purchaser, "surName", $$v)
                                        },
                                        expression: "purchaser.surName"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "allPurchaser." + index + ".address"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "Address" },
                                      model: {
                                        value: purchaser.address,
                                        callback: function($$v) {
                                          _vm.$set(purchaser, "address", $$v)
                                        },
                                        expression: "purchaser.address"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "allPurchaser." + index + ".suburb"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "Suburb" },
                                      model: {
                                        value: purchaser.suburb,
                                        callback: function($$v) {
                                          _vm.$set(purchaser, "suburb", $$v)
                                        },
                                        expression: "purchaser.suburb"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "allPurchaser." + index + ".state"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { display: "inline" },
                                        attrs: { placeholder: "State" },
                                        model: {
                                          value: purchaser.state,
                                          callback: function($$v) {
                                            _vm.$set(purchaser, "state", $$v)
                                          },
                                          expression: "purchaser.state"
                                        }
                                      },
                                      _vm._l(_vm.listingStates, function(
                                        state
                                      ) {
                                        return _c("el-option", {
                                          key: state.id,
                                          attrs: {
                                            label: state.stateName,
                                            value: state.stateName
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop:
                                        "allPurchaser." + index + ".postcode"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "Postcode" },
                                      model: {
                                        value: purchaser.postcode,
                                        callback: function($$v) {
                                          _vm.$set(purchaser, "postcode", $$v)
                                        },
                                        expression: "purchaser.postcode"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "Phone" },
                                      model: {
                                        value: purchaser.mobile,
                                        callback: function($$v) {
                                          _vm.$set(purchaser, "mobile", $$v)
                                        },
                                        expression: "purchaser.mobile"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "allPurchaser." + index + ".email"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "Email" },
                                      model: {
                                        value: purchaser.email,
                                        callback: function($$v) {
                                          _vm.$set(purchaser, "email", $$v)
                                        },
                                        expression: "purchaser.email"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "center"
                          },
                          attrs: { span: 24 }
                        },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "color-green btn-add-purchaser",
                                  staticStyle: {
                                    "justify-content": "center",
                                    "border-bottom": "1px solid #003333",
                                    "padding-bottom": "2px"
                                  },
                                  attrs: { type: "text" },
                                  on: { click: _vm.addAnotherPurchaser }
                                },
                                [
                                  _vm._v(
                                    "\n                  Add another purchaser's details\n                "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c("el-input", {
                                attrs: { placeholder: "Purchasing entity" },
                                model: {
                                  value: _vm.purchasingEntity,
                                  callback: function($$v) {
                                    _vm.purchasingEntity = $$v
                                  },
                                  expression: "purchasingEntity"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c(
                          "span",
                          { staticClass: "text-dino text-18 text-w400" },
                          [
                            _vm._v(
                              "Only complete if you are purchasing outside of your personal\n                name"
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.$route.query.type == "1"
                    ? _c(
                        "el-row",
                        { staticStyle: { "margin-top": "20px" } },
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c(
                              "span",
                              { staticClass: "title-reservation-section" },
                              [_vm._v("Make an offer")]
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$route.query.type == "1"
                    ? _c(
                        "el-row",
                        { staticStyle: { "margin-top": "10px" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "payment.offerAmount" } },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "Make an offer" },
                                    model: {
                                      value:
                                        _vm.reservationForm.payment.offerAmount,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.reservationForm.payment,
                                          "offerAmount",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "reservationForm.payment.offerAmount"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticStyle: { "margin-top": "25px" } },
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c(
                          "span",
                          { staticClass: "title-reservation-section" },
                          [_vm._v("Deposit")]
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticStyle: { "margin-top": "20px" } },
                    [
                      _c(
                        "el-col",
                        { staticClass: "mb-10", attrs: { span: 24 } },
                        [
                          _c(
                            "span",
                            { staticClass: "text-dino text-18 text-w400" },
                            [_vm._v("How will your client pay their deposit?")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "depositPayingMethod" } },
                            [
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          staticClass: "vertical-radio-group",
                                          staticStyle: {
                                            width: "100%",
                                            padding: "5px 0"
                                          },
                                          model: {
                                            value:
                                              _vm.reservationForm
                                                .depositPayingMethod,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.reservationForm,
                                                "depositPayingMethod",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "reservationForm.depositPayingMethod"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            {
                                              attrs: {
                                                label:
                                                  _vm.DEPOSIT.CASH_TRANSFER
                                                    .value,
                                                border: ""
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.DEPOSIT.CASH_TRANSFER
                                                    .label
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          staticClass: "vertical-radio-group",
                                          staticStyle: {
                                            width: "100%",
                                            padding: "5px 0"
                                          },
                                          model: {
                                            value:
                                              _vm.reservationForm
                                                .depositPayingMethod,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.reservationForm,
                                                "depositPayingMethod",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "reservationForm.depositPayingMethod"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            {
                                              attrs: {
                                                label:
                                                  _vm.DEPOSIT.BANK_GUARANTEE
                                                    .value,
                                                border: ""
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.DEPOSIT.BANK_GUARANTEE
                                                    .label
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          staticClass: "vertical-radio-group",
                                          staticStyle: {
                                            width: "100%",
                                            padding: "5px 0"
                                          },
                                          model: {
                                            value:
                                              _vm.reservationForm
                                                .depositPayingMethod,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.reservationForm,
                                                "depositPayingMethod",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "reservationForm.depositPayingMethod"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            {
                                              attrs: {
                                                label:
                                                  _vm.DEPOSIT.DEPOSIT_BOND
                                                    .value,
                                                border: ""
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.DEPOSIT.DEPOSIT_BOND.label
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "deposit-bond-description"
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: { color: "#647979" }
                                            },
                                            [
                                              _c("em", [
                                                _vm._v(
                                                  "(Deposit bonds can replace cash and help buyers secure property sooner – "
                                                ),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "text-dino",
                                                    attrs: {
                                                      href:
                                                        "https://www.downsizer.com/agents_u-connect",
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [_vm._v("click here")]
                                                ),
                                                _vm._v(" to find out more)")
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { prop: "infoFromDepositBondPartner" } },
                            [
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    {
                                      staticStyle: { "margin-top": "3vh" },
                                      attrs: { span: 24 }
                                    },
                                    [
                                      _c("el-checkbox", {
                                        attrs: {
                                          label:
                                            _vm.DEPOSIT.DEPOSIT_BOND_INFO.label,
                                          border: ""
                                        },
                                        model: {
                                          value:
                                            _vm.reservationForm
                                              .infoFromDepositBondPartner,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.reservationForm,
                                              "infoFromDepositBondPartner",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "reservationForm.infoFromDepositBondPartner"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "deposit-bond-description"
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: { color: "#647979" }
                                            },
                                            [
                                              _c("em", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.DEPOSIT
                                                      .DEPOSIT_BOND_INFO
                                                      .description
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    {
                      staticStyle: { "margin-top": "10px" },
                      attrs: { gutter: 20 }
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "color-green text-w400 text-dino text-18"
                            },
                            [_vm._v("Colour scheme collection")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { prop: "colourSchemeCollection" } },
                            [
                              _c("el-input", {
                                staticStyle: { "margin-top": "5px" },
                                attrs: {
                                  placeholder: "Colour scheme collection"
                                },
                                model: {
                                  value:
                                    _vm.reservationForm.colourSchemeCollection,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.reservationForm,
                                      "colourSchemeCollection",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "reservationForm.colourSchemeCollection"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "color-green text-w400 text-dino text-18"
                            },
                            [
                              _vm._v(
                                "Additional comments for contract instructions"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { prop: "additionalComments" } },
                            [
                              _c("el-input", {
                                staticStyle: { "margin-top": "5px" },
                                attrs: { placeholder: "Additional comments" },
                                model: {
                                  value: _vm.reservationForm.additionalComments,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.reservationForm,
                                      "additionalComments",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "reservationForm.additionalComments"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    {
                      staticStyle: { "margin-top": "10px" },
                      attrs: { gutter: 20 }
                    },
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c("p", { staticClass: "instruction-text" }, [
                          _vm._v(
                            "\n                Please send a copy of your Driver’s License or Passport to\n                "
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "email-link",
                              attrs: { href: "mailto:team@unifiproperty.com" }
                            },
                            [_vm._v("team@unifiproperty.com")]
                          )
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticStyle: { "margin-top": "20px" } },
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c(
                          "span",
                          { staticClass: "title-reservation-section" },
                          [_vm._v("Purchaser's Conveyancer / Solicitor")]
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticStyle: { "margin-top": "20px" } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center"
                                  },
                                  on: { change: _vm.conveyancerCheckboxToggle },
                                  model: {
                                    value: _vm.checked,
                                    callback: function($$v) {
                                      _vm.checked = $$v
                                    },
                                    expression: "checked"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "color-green text-w400 text-dino text-18"
                                    },
                                    [
                                      _vm._v(
                                        "Please check the box if you would like to nominate a\n                    different conveyancer or solicitor and complete the\n                    fields below"
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c("el-input", {
                                attrs: { placeholder: "Company Name" },
                                model: {
                                  value: _vm.reservationForm.legal.companyName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.reservationForm.legal,
                                      "companyName",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "reservationForm.legal.companyName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c("el-input", {
                                attrs: { placeholder: "Email" },
                                model: {
                                  value: _vm.reservationForm.legal.email,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.reservationForm.legal,
                                      "email",
                                      $$v
                                    )
                                  },
                                  expression: "reservationForm.legal.email"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c("el-input", {
                                attrs: { placeholder: "Address" },
                                model: {
                                  value: _vm.reservationForm.legal.address,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.reservationForm.legal,
                                      "address",
                                      $$v
                                    )
                                  },
                                  expression: "reservationForm.legal.address"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c("el-input", {
                                attrs: { placeholder: "Suburb" },
                                model: {
                                  value: _vm.reservationForm.legal.suburb,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.reservationForm.legal,
                                      "suburb",
                                      $$v
                                    )
                                  },
                                  expression: "reservationForm.legal.suburb"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { display: "inline" },
                                  attrs: { placeholder: "State" },
                                  model: {
                                    value: _vm.reservationForm.legal.state,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.reservationForm.legal,
                                        "state",
                                        $$v
                                      )
                                    },
                                    expression: "reservationForm.legal.state"
                                  }
                                },
                                _vm._l(_vm.listingStates, function(state) {
                                  return _c("el-option", {
                                    key: state.id,
                                    attrs: {
                                      label: state.stateName,
                                      value: state.stateName
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c("el-input", {
                                attrs: { placeholder: "Postcode" },
                                model: {
                                  value: _vm.reservationForm.legal.postcode,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.reservationForm.legal,
                                      "postcode",
                                      $$v
                                    )
                                  },
                                  expression: "reservationForm.legal.postcode"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c("el-input", {
                                attrs: { placeholder: "Landline" },
                                model: {
                                  value: _vm.reservationForm.legal.phone,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.reservationForm.legal,
                                      "phone",
                                      $$v
                                    )
                                  },
                                  expression: "reservationForm.legal.phone"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c("el-input", {
                                attrs: { placeholder: "Mobile" },
                                model: {
                                  value: _vm.reservationForm.legal.mobile,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.reservationForm.legal,
                                      "mobile",
                                      $$v
                                    )
                                  },
                                  expression: "reservationForm.legal.mobile"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c(
                          "span",
                          { staticClass: "title-reservation-section" },
                          [_vm._v("Agent's Details")]
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: { "margin-top": "10px" },
                          attrs: { span: 24 }
                        },
                        [
                          _c(
                            "el-form-item",
                            { staticClass: "mb-0" },
                            [
                              _c(
                                "el-col",
                                {
                                  staticClass: "text-dino text-20 color-green",
                                  attrs: { span: 24 }
                                },
                                [
                                  _c("span", { staticClass: "text-w600" }, [
                                    _vm._v("Company Name")
                                  ]),
                                  _vm._v(" "),
                                  _c("el-divider", {
                                    staticClass: "mlf-5",
                                    attrs: { direction: "vertical" }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "text-w400" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.listingDetails.agencyDetails.name
                                      )
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { staticClass: "mb-0" },
                            [
                              _c(
                                "el-col",
                                {
                                  staticClass: "text-dino text-20 color-green",
                                  attrs: { span: 24 }
                                },
                                [
                                  _c("span", { staticClass: "text-w600" }, [
                                    _vm._v("Contact Person")
                                  ]),
                                  _vm._v(" "),
                                  _c("el-divider", {
                                    staticClass: "mlf-5",
                                    attrs: { direction: "vertical" }
                                  }),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.listingDetails.agentsDetails,
                                    function(agent, index) {
                                      return _c(
                                        "span",
                                        {
                                          key: index,
                                          staticClass: "text-w400"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(agent.firstName.trim()) +
                                              " " +
                                              _vm._s(agent.lastName.trim())
                                          ),
                                          index <
                                          _vm.listingDetails.agentsDetails
                                            .length -
                                            1
                                            ? _c("span", [_vm._v(", ")])
                                            : _vm._e()
                                        ]
                                      )
                                    }
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { staticClass: "mb-0" },
                            [
                              _c(
                                "el-col",
                                {
                                  staticClass: "text-dino text-20 color-green",
                                  attrs: { span: 24 }
                                },
                                [
                                  _c("span", { staticClass: "text-w600" }, [
                                    _vm._v("Address")
                                  ]),
                                  _vm._v(" "),
                                  _c("el-divider", {
                                    staticClass: "mlf-5",
                                    attrs: { direction: "vertical" }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "text-w400" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.listingDetails.agencyDetails.address.trim()
                                      ) +
                                        ", " +
                                        _vm._s(
                                          _vm.listingDetails.agencyDetails.suburb.trim()
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.listingDetails.agencyDetails.state.trim()
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.listingDetails.agencyDetails.postcode.trim()
                                        )
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { staticClass: "mb-0" },
                            [
                              _c(
                                "el-col",
                                {
                                  staticClass: "text-dino text-20 color-green",
                                  attrs: { span: 24 }
                                },
                                [
                                  _c("span", { staticClass: "text-w600" }, [
                                    _vm._v("Phone Number")
                                  ]),
                                  _vm._v(" "),
                                  _c("el-divider", {
                                    staticClass: "mlf-5",
                                    attrs: { direction: "vertical" }
                                  }),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.listingDetails.agentsDetails,
                                    function(agent, index) {
                                      return _c(
                                        "span",
                                        {
                                          key: index,
                                          staticClass: "text-w400"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(agent.phoneNumber.trim())
                                          ),
                                          index <
                                          _vm.listingDetails.agentsDetails
                                            .length -
                                            1
                                            ? _c("span", [_vm._v(", ")])
                                            : _vm._e()
                                        ]
                                      )
                                    }
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { staticClass: "mb-0" },
                            [
                              _c(
                                "el-col",
                                {
                                  staticClass: "text-dino text-20 color-green",
                                  attrs: { span: 24 }
                                },
                                [
                                  _c("span", { staticClass: "text-w600" }, [
                                    _vm._v("Email")
                                  ]),
                                  _vm._v(" "),
                                  _c("el-divider", {
                                    staticClass: "mlf-5",
                                    attrs: { direction: "vertical" }
                                  }),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.listingDetails.agentsDetails,
                                    function(agent, index) {
                                      return _c(
                                        "span",
                                        {
                                          key: index,
                                          staticClass: "text-w400"
                                        },
                                        [
                                          _vm._v(_vm._s(agent.email)),
                                          index <
                                          _vm.listingDetails.agentsDetails
                                            .length -
                                            1
                                            ? _c("span", [_vm._v(", ")])
                                            : _vm._e()
                                        ]
                                      )
                                    }
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.listingDetails.price != 0 && _vm.$route.query.type == "2"
                    ? _c(
                        "el-row",
                        [
                          _c("el-col", {
                            ref: "checkout",
                            attrs: { id: "checkout", span: 24 }
                          }),
                          _vm._v(" "),
                          _vm.checkoutDisplayed
                            ? _c(
                                "el-col",
                                {
                                  staticStyle: { "margin-top": "10px" },
                                  attrs: { span: 24 }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "text-dino text-20 text-w400"
                                    },
                                    [
                                      _vm._v(
                                        "Please note the $1000 reservation fee is fully refunded to\n                you after a 7 day holding period. Please note that it may take\n                3-5 business days for the reimbursed funds to clear in your\n                account. An additional transactional fee of 3% + 30c for\n                domestic and international cards is a non-refundable\n                fee."
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.checkoutDisplayed
                            ? _c(
                                "el-col",
                                {
                                  staticStyle: { "margin-top": "10px" },
                                  attrs: { span: 24 }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "text-dino text-20 text-w400"
                                    },
                                    [
                                      _vm._v(
                                        "Secure payment transactions powered by Stripe and secure with\n                256-bit encryption"
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticStyle: { "margin-top": "10px" } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _vm.$route.query.type == "1"
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "btn-pay-submit btn-offer-p",
                                  on: { click: _vm.submitReservation }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "text-w400 text-dino text-22"
                                    },
                                    [_vm._v("Submit Offer")]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$route.query.type == "2" && !_vm.checkoutDisplayed
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "btn-pay-submit btn-select-p",
                                  on: { click: _vm.submitReservation }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "text-w400 text-dino text-22"
                                    },
                                    [_vm._v("Pay and Submit Reservation")]
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticStyle: { "margin-top": "10px" } },
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _vm.$route.query.type == "2"
                          ? _c(
                              "span",
                              { staticClass: "text-dino text-22 text-w400" },
                              [
                                _vm._v(
                                  "Congratulations on your property reservation. Your real\n                estate agent will be in touch shortly."
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$route.query.type == "1"
                          ? _c(
                              "span",
                              { staticClass: "text-dino text-22 text-w400" },
                              [
                                _vm._v(
                                  "Congratulations. Your real estate agent will be in touch\n                shortly."
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ecb4a646", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecb4a646","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uConnectReservation/reservationFormSection.vue
// module id = null
// module chunks = 